import { LanguageSkill, PersonLanguage } from "../models/languageSkill.model";
import { BackendHttpService } from "./backendHttpService";

export class LanguageSkillService extends BackendHttpService {
  constructor() {
    super("PersonLanguage");
  }

  async getDataByPersonID(personId: number): Promise<PersonLanguage[]> {
    try {
      const personLanguages = await this.get<PersonLanguage[]>(
        `/byUserId/${personId}`
      );
      return personLanguages || [];
    } catch (error) {
      console.error(`Error getting language items for person ${personId}:`, error);
      throw error;
    }
  }

  async addData(data: LanguageSkill): Promise<PersonLanguage> {
    return this.addLanguageSkill(data);
  }

  async updateData(data: LanguageSkill): Promise<PersonLanguage> {
    return this.updateLanguageSkill(data);
  }

  async deleteData(data: LanguageSkill): Promise<void> {
    return this.deleteLanguageSkill(data);
  }

  async addLanguageSkill(
    languageSkill: LanguageSkill
  ): Promise<PersonLanguage> {
    try {
      const payload = {
        userID: languageSkill.userId,
        language: languageSkill.languageId,
        proficiency: languageSkill.proficiencyId,
      };
      const result = await this.post<typeof payload, PersonLanguage>(payload);
      return result;
    } catch (error) {
      console.error("Error adding language skill:", error);
      throw error;
    }
  }

  async updateLanguageSkill(
    languageSkill: LanguageSkill
  ): Promise<PersonLanguage> {
    try {
      const payload = {
        id: languageSkill.id,
        userID: languageSkill.userId,
        language: languageSkill.languageId,
        proficiency: languageSkill.proficiencyId,
      };
      const result = await this.put<typeof payload, PersonLanguage>(
        payload,
        languageSkill.id.toString()
      );
      return result;
    } catch (error) {
      console.error("Error updating language skill:", error);
      throw error;
    }
  }

  async deleteLanguageSkill(languageSkill: LanguageSkill): Promise<void> {
    try {
      await this.delete(languageSkill.id.toString());
    } catch (error) {
      console.error("Error deleting language skill:", error);
      throw error;
    }
  }
}
